import React,{useState,useEffect} from 'react'
import {URL} from '../Helper/helper';
import CustomTableComponent from '../Bookings/CustomTableComponent';
import './AdminComponent.css'

function CustomAdminComponent() {
 
  const user_info = JSON.parse(localStorage.getItem('user')) 
  const[reservations,setReservations] = useState([]) 
  const[perReservations,setPerReservations] = useState([])
  
  useEffect(() =>{
    async function invokeUsers(){

        const user_reservations = await fetch(`${URL}`+'/perbookings')
        const cust_per_booking_response = await user_reservations.json()
        console.log('PCustomers :',cust_per_booking_response)
        localStorage.setItem('perReservations',JSON.stringify(cust_per_booking_response))
        setPerReservations(cust_per_booking_response)
    }

    invokeUsers()
  },[])

  return (
    <div className='admin-panel'>
        <CustomTableComponent />
    </div>
  )
}

export default CustomAdminComponent